// extracted by mini-css-extract-plugin
export default {"myAccount":"myAccount_myAccount__1Fx29"};